import { QBItemSelection } from '@/components/query-builder/models';

export interface PTProps {
  matchType: 'manual' | 'rule';
  manualProducts?: PTProductsSelection[];
  rules?: PTRulesSelection;

  quiz?: PTQuiz;
  pages?: PTPages;
}

export function defaultPTProps(): PTProps {
  return {
    matchType: `manual`,
    manualProducts: [],
    rules: {
      offsetType: `percent`,
      priceOffset: 0,
      rules: [],
    },
    quiz: {
      hasSplitPayments: PTQuizAnswer.NOT_SURE,
      priceShownOnButtons: PTQuizAnswer.NOT_SURE,
      bundles: PTQuizAnswer.NOT_SURE,
      custom: ``,
    },
    pages: {
      homepage: true,
      search: true,
      collections: true,
      productPage: true,
      cart: true,
      quiz: false,
      popups: false,
      blogs: false,
      others: [],
    },
  };
}

export type PTOffsetType = 'fixed' | 'percent' | 'final';

export interface PTRulesSelection {
  rules: QBItemSelection[];
  offsetType: PTOffsetType;
  priceOffset: number;
}

export interface PTProductsSelection {
  id: string;
  handle: string;
  offsetType: PTOffsetType;
  priceOffset: number;

  title: string;
  image: string;
  price: number;
  compareAtPrice: number;
}

export interface PTQuiz {
  hasSplitPayments: PTQuizAnswer;
  priceShownOnButtons: PTQuizAnswer;
  bundles: PTQuizAnswer;
  custom: string;
}

export enum PTQuizAnswer {
  YES = `YES`,
  NO = `NO`,
  NOT_SURE = `NOT_SURE`,
}

export interface PTPages {
  homepage?: boolean;
  search?: boolean;
  collections?: boolean;
  productPage?: boolean;
  cart?: boolean;
  quiz?: boolean;
  popups?: boolean;
  blogs?: boolean;
  others?: string[];
}

export enum PTConfigStep {
  MATCH_STEP = `MATCH_STEP`,
  QUIZ_STEP = `QUIZ_STEP`,
  PAGES_STEP = `PAGES_STEP`,
  DONE_STEP = `DONE_STEP`,
}
